import get from 'lodash/get';
import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'paperwork.paperworkAppointmentSession');

export const selectPaperworkAppointmentSessionSending = createSelector(
  selectRootState,
  state => get(state, 'sending', false),
);

export const selectPaperworkAppointmentSessionError = createSelector(
  selectRootState,
  state => get(state, 'error', false),
);



// WEBPACK FOOTER //
// ./src/redux/paperwork/selectors/paperwork-appointment-session.js